import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageConstants } from 'src/app/core/constants/message';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { TipoMovimeintoDialogService } from './tipo-movimiento-dialog.service';
import {IRequest, IResponse} from "./tipo-movimiento-dialog.model";
import {TextValidatorService} from "../../../core/validators/text-validator.service";
import { ISort } from 'src/app/core/interfaces/sort';

@Component({ standalone: false,
  selector: 'app-tipo-movimiento-dialog',
  templateUrl: './tipo-movimiento-dialog.component.html',

  styleUrls: ['./tipo-movimiento-dialog.component.css']
})
export class TipoMovimientoDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);

  isFirstLoad: boolean = true;
  totalRows: number = 0;
  lsData: IRequest[] = [];
  codigosMessage: any;
  mensajesMessage: any;
  loaded: boolean = true;

  constructor(private personaDialogService: TipoMovimeintoDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private readonly textValidatorService: TextValidatorService){
  }

  ngOnInit(): void {
    let dataReq: IResponse = {
      Codigo:null,
      Nombre:null,
      Activo: true,
      Offset:0,
      Take:10,
      Sort:""
    };
    this.getData(dataReq);
  }

  loadLazy(event: any) {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      return;
    }
    let dataReq: IResponse = {
      Codigo:null,
      Nombre:null,
      Activo: true,
      Offset:event.first,
      Take:event.rows,
      Sort:""
    };

    let sortCol = event.sortField;
    let sortColOrder = event.sortOrder;
    let sortStr = "";
    if (!(sortCol === undefined || sortCol ===null)){
      let sortArray: ISort[] = [];
      let sortObj: ISort ={
        Selector: sortCol,
        Desc: sortColOrder !== 1,
      };
      sortArray.push(sortObj);
      sortStr = JSON.stringify(sortArray);
    }
    dataReq.Sort = sortStr;

    let filterObj = event.filters;
    if(filterObj.hasOwnProperty('Codigo')){
      dataReq.Codigo = filterObj['Codigo']['value'];
    }
    if(filterObj.hasOwnProperty('Nombre')){
      dataReq.Nombre = filterObj['Nombre']['value'];
    }

    this.getData(dataReq);
  }

  getData(request: IResponse){
    this.loaded = false;
    setTimeout(() => { this.cdr?.detectChanges(); });
    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.personaDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp =data;
            if(dataTmp) {
              this.lsData = dataTmp;
            }
            setTimeout(() => { this.cdr?.detectChanges(); });
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
            this.loaded = true;
            setTimeout(() => { this.cdr?.detectChanges(); });
          },
          complete: () => {
            this.loaded = true;
            setTimeout(() => { this.cdr?.detectChanges(); });
          }
        }
      );
  }

  onRowDblClick(event: any, dataSelected: any){
    if(dataSelected){
      let _description = ((dataSelected.Codigo) ? dataSelected.Codigo : "" ) + " - " + ((dataSelected.Nombre) ? dataSelected.Nombre: "") ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

  onKeyDownLetters = (event: any) => this.textValidatorService.validateOnlyLetters(event);
  onKeyDownLettersAndNumbers = (event: any) => this.textValidatorService.validateOnlyLettersAndNumbers(event);
}
